import { useState, useCallback } from 'react';

export interface DebugNavigationRequest {
  section: string;
  key: number;
}

export function useDebugSectionFocus(sectionIds: string[]) {
  const [focusedSection, setFocusedSection] = useState(sectionIds[0]);
  const [navigationRequest, setNavigationRequest] = useState<DebugNavigationRequest>({ section: '', key: 0 });

  const sectionProps = useCallback(
    (sectionId: string) => ({
      onClick: () => setFocusedSection(sectionId),
      onFocus: () => setFocusedSection(sectionId),
    }),
    [],
  );

  const navigateToSection = useCallback((section: string) => {
    setFocusedSection(section);
    setNavigationRequest(prev => ({ section, key: prev.key + 1 }));
  }, []);

  return { focusedSection, sectionProps, navigateToSection, navigationRequest };
}
